import { call, delay, put, select } from 'redux-saga/effects';
import { contractDataActions as actions } from './index';
import { request } from '../../../../utils/request';
import { biDetailState, ContractErrorType } from './types';
import { selectContractNumber } from './selectors';
import { apiList } from '../../../../locales/apiList';
import { toPathSegment } from '../../../../utils/contractNumber';

/**
 * Github repos request/response handler
 */
export function* getBI() {
  yield delay(250); // run setContractNumber first
  const contractNumber = yield select(selectContractNumber);
  const requestURL = `${process.env.REACT_APP_WEB_BI_API_URL}${apiList.getBIURL}${toPathSegment(contractNumber)}`;
  try {
    if (contractNumber) {
      const repos: biDetailState = yield call(request, requestURL);
      yield put(actions.reposLoaded(repos));
    }
  } catch (err: any) {
    if (err.response?.status === 404) {
      yield put(actions.setContractError(ContractErrorType.NOT_FOUND));
    } else if (err.response?.status === 401) {
      yield put(actions.setContractError(ContractErrorType.UNAUTHORIZED));
    } else if (err.response?.status === 403) {
      yield put(actions.setContractError(ContractErrorType.FORBIDDEN));
    } else if (err.response?.status >= 500) {
      yield put(actions.setContractError(ContractErrorType.SERVER_ERROR));
    } else if (err.message === 'Failed to fetch') {
      yield put(actions.setContractError(ContractErrorType.NETWORK_ERROR));
    } else {
      yield put(actions.setContractError(ContractErrorType.SERVER_ERROR));
    }
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* contractDataSaga() {
  // Watches for loadRepos actions and calls getRepos when one comes in.
  // By using `takeLatest` only the result of the latest API call is applied.
  // It returns task descriptor (just like fork) so we can continue execution
  // It will be cancelled automatically on component unmount

  yield getBI();
  // yield takeLatest(actions.changeCustomerName.type, getRepos);
}